import { jwtDecode } from "jwt-decode";
import React, { createContext, useContext, useEffect, useState } from "react";
import { LoginAccount } from "types";

interface AuthContextProps {
  isAuthenticated: boolean;
  loginData: LoginAccount | null;
  // user: User;
  // adminUnitDetail: AdminUnit | {};
  token: string;
  setLoginData: (token: LoginAccount | null) => void;
  logout: () => void;
}
type UpdateAuth = (auth: AuthContextProps) => void;
export interface User {
  id: string;
  access: string;
  refresh?: string;
  user_id: string;
  username: string;
  email?: string;
  permissions: string[];
  roles: string[];
  employee_id: string;
  admin_unit: string;
  org_unit: string;
  user_type: string;
  is_superuser?: boolean;
  full_name: string;
}

export interface JwtPayload {
  exp?: number; // Expiration time in seconds
  iat?: number; // Issued at
  sub?: string; // Subject (user id, etc.)
  [key: string]: any; // Any additional claims
}

export function isValidJwtFormat(token: string): boolean {
  if (!token || typeof token !== "string") return false;

  const parts = token.split(".");
  if (parts.length !== 3) return false;

  // Check if all parts are non-empty
  return parts.every((part) => part.trim().length > 0);
}

export function getTokenPayloadSafely(
  token: string | null | undefined
): JwtPayload | null {
  if (!token || !isValidJwtFormat(token)) {
    console.warn("Invalid or missing token format");
    return null;
  }

  try {
    return jwtDecode<JwtPayload>(token);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [loginData, setLoginData] = useState<LoginAccount | null>(null);

  useEffect(() => {
    const storedToken: any = getTokenPayloadSafely(
      sessionStorage.getItem("authToken") || "{}"
    );
    setLoginData(storedToken);
  }, []);

  useEffect(() => {
    if (loginData?.access) {
    }
  }, [loginData]);

  const logout = () => {
    sessionStorage.removeItem("authToken");
    setLoginData(null);
  };

  const value = {
    isAuthenticated: !!loginData?.access,
    loginData,
    token: loginData?.access || "",
    setLoginData,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const AuthUpdateContext = React.createContext<UpdateAuth>(() => {});

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export function useAuthUpdate() {
  return useContext(AuthUpdateContext);
}
